import { getRequest, postRequest, patchRequest, deleteRequest } from '../request/request.service';
import {
  RedirectionTargetsListResponse,
  RedirectionTargetResponse,
  CreateRedirectionTargetPayload,
  UpdateRedirectionTargetPayload,
  RedirectionTargetsQueryParams,
} from './redirection-targets-service.types';

export function getRedirectionTargets(params?: RedirectionTargetsQueryParams) {
  const queryParams = new URLSearchParams();

  if (params?.page) queryParams.append('page', params.page.toString());
  if (params?.items_per_page) queryParams.append('items_per_page', params.items_per_page.toString());
  if (params?.search) queryParams.append('search', params.search);
  if (params?.company_id) queryParams.append('company_id', params.company_id.toString());

  const queryString = queryParams.toString();
  const url = queryString ? `redirection_targets?${queryString}` : 'redirection_targets';

  return getRequest<RedirectionTargetsListResponse>(url);
}

export function getRedirectionTarget(id: number) {
  return getRequest<RedirectionTargetResponse>(`redirection_targets/${id}`);
}

export function createRedirectionTarget(companyId: number, payload: CreateRedirectionTargetPayload) {
  return postRequest<RedirectionTargetResponse>(`redirection_targets?company_id=${companyId}`, { data: payload });
}

export function updateRedirectionTarget(id: number, companyId: number, payload: UpdateRedirectionTargetPayload) {
  return patchRequest<RedirectionTargetResponse>(`redirection_targets/${id}?company_id=${companyId}`, { data: payload });
}

export function deleteRedirectionTarget(id: number, companyId?: number) {
  const url = companyId
    ? `redirection_targets/${id}?company_id=${companyId}`
    : `redirection_targets/${id}`;
  return deleteRequest<void>(url);
}
